export const typeOptions = [
  { value: 'INDIVIDUAL_CONTRACT', en: 'Contract', el: 'Συμβόλαιο' },
  { value: 'PREPAID_CONTRACT', en: 'Prepaid Card / Cost Control', el: 'Καρτοκινητή / Καρτοσυμβόλαιο' },
];

export const formInitialValues = {
  country: null,
  type: typeOptions[0],
};

export const GREEKLISH_MAP = [
  ['th', 'θ'],
  ['ch', 'χ'],
  ['ps', 'ψ'],
  ['ks', 'ξ'],
  ['ou', 'ου'],
  ['ai', 'αι'],
  ['ei', 'ει'],
  ['oi', 'οι'],
  ['mp', 'μπ'],
  ['nt', 'ντ'],
  ['gk', 'γκ'],
  ['gg', 'γγ'],
  ['a', 'α'],
  ['b', 'β'],
  ['v', 'β'],
  ['g', 'γ'],
  ['d', 'δ'],
  ['e', 'ε'],
  ['z', 'ζ'],
  ['h', 'η'],
  ['i', 'ι'],
  ['k', 'κ'],
  ['l', 'λ'],
  ['m', 'μ'],
  ['n', 'ν'],
  ['x', 'ξ'],
  ['o', 'ο'],
  ['p', 'π'],
  ['r', 'ρ'],
  ['s', 'σ'],
  ['t', 'τ'],
  ['u', 'υ'],
  ['y', 'υ'],
  ['f', 'φ'],
  ['w', 'ω'],
];
